import React from "react";
import PropTypes from "prop-types";
import { UiButton } from "ui-components";

/**
 * اکشن افزودن شاخص آنالیز به رکورد
 * @param {*Object} action آبجکت اکشن
 * @param {*Number} itemId شناسه رکورد
 */
const UiActionAnalyzer = ({ action }) => {
    return (
        <UiButton
            type="icon"
            className={`icon ${action.icon}`}
            size="xxs"
            tooltip={action.tooltip}
            disabled={action.disabled}
        />
    );
};
UiActionAnalyzer.propTypes = {
    action: PropTypes.object,
    itemId: PropTypes.number,
};

export default UiActionAnalyzer;
